import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ImageOff } from "lucide-react";

type NativeImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

interface ImageProps extends NativeImageProps {
  fallback?: React.ReactNode;
  handleOnLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  imgRef?: React.Ref<HTMLImageElement>;
}

export const Image: React.FC<ImageProps> = ({
  fallback,
  handleOnLoad,
  imgRef,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  if (error) {
    return <>{fallback ?? <ImageOff size={20} />}</>;
  }

  if (!props.src && fallback) {
    return <>{fallback}</>;
  }

  if (!props.src && !fallback) {
    return <ImageOff size={20} />;
  }

  return (
    <>
      {!loaded && <Skeleton height={props.height} width={props.width} />}
      <img
        ref={imgRef}
        src={props.src}
        loading={props.loading ?? "lazy"}
        onLoad={(e) => {
          setLoaded(true);
          if (handleOnLoad) {
            handleOnLoad(e);
          }
        }}
        onError={() => setError(true)}
        style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.2s ease",
        }}
        {...props}
      />
    </>
  );
};
